import { Toc, TocItem } from "@gravity-ui/uikit";
import cn from "classnames";
import { RoutePathKeys } from "src/widgets/KnowledgeBase/constants";

import styles from "./KnowledgeToc.module.scss";

interface KnowledgeTocProps {
  activeId: string | null;
  items: TocItem[];
  onClick?: () => void;
  route?: RoutePathKeys;
}

export const KnowledgeToc = ({
  items,
  activeId,
  onClick,
  route,
}: KnowledgeTocProps) => {
  return (
    <div
      className={cn(
        styles.layoutToc,
        route === "base" ? styles.layoutBase : styles.layoutDefault,
      )}
    >
      <Toc
        items={items}
        value={activeId ?? items?.[0]?.value}
        onItemClick={onClick}
      />
    </div>
  );
};
